import { render, staticRenderFns } from "./UpdateTransportTime.vue?vue&type=template&id=10857ed6&"
import script from "./UpdateTransportTime.vue?vue&type=script&lang=js&"
export * from "./UpdateTransportTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports